import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GetDepositHistory } from '../Api/GetDepositHistory';
import { Flip, toast } from 'react-toastify';
import { Context } from '../Context/Context';
import { Helmet } from 'react-helmet'
export default function DepositHistory() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [despositHistoryData, setDepositHistoryData] = useState([]);
    const { setLoad, setLoadColor, numberModal, sideBarOpen } = useContext(Context);

    const handleDepositHistory = useCallback(async () => {
        setLoad(true);
        setLoadColor("#434343");
        let data = {
            username: JSON.parse(localStorage.getItem('userinfo'))?.username
        };
        let res = await GetDepositHistory(data);
        if (res) {
            if (res.data.status) {
                setDepositHistoryData(res.data.data);
            } else {
                toast.error(res.data.message, {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                });
            }
            setLoad(false);
        }
    }, [setLoad, setLoadColor]);

    useEffect(() => {
        if (pathname === "/deposit/depositHistory" && !numberModal && !sideBarOpen) {
            handleDepositHistory();
        }
    }, [pathname, numberModal, sideBarOpen, handleDepositHistory]);

    return (
        <div className='depositContainer'>
            <Helmet>
                {/* Page Title */}
                <title>Deposit History | Track Your Transactions | Matka Jantri</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="View your complete deposit history on MatkaJantri. Keep track of all your secure transactions and payment details with ease."
                />

                {/* SEO Directives */}
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://app.matkajantri.com/deposit-history" />

                {/* Favicon and Icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph */}
                <meta property="og:title" content="Deposit History | Track Your Transactions | MatkaJantri" />
                <meta
                    property="og:description"
                    content="View your complete deposit history on MatkaJantri. Keep track of all your secure transactions and payment details with ease."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://app.matkajantri.com" />
                <meta property="og:image" content="https://app.matkajantri.com/Logo.png" />
                <meta name="google-site-verification" content="d6d81656210c6db7" />
            </Helmet>
            <div className="wrapper" style={{ marginTop: "0px" }}>
                <div className="section">
                    <div className="top_navbar" style={{ height: "60px" }}>
                        <div className="hamburger">
                            <button
                                className='back_btn'
                                onClick={() => navigate("/game")}
                                style={{ background: 'none', border: 'none' }}
                            >
                                <i className="fa-solid fa-chevron-left"></i>
                            </button>
                        </div>
                        <div className='gameName'>Deposit History</div>
                    </div>
                </div>
            </div>

            <div className="Tablecontainer" style={{ marginTop: "60px", width: "100%" }}>
                <table>
                    <thead>
                        <tr>
                            <th>Transaction ID</th>
                            <th>Amount</th>
                            <th>Remark</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {despositHistoryData?.map((ele, i) => (
                            <tr key={i}>
                                <td>{ele?.transaction_id}</td>
                                <td>{ele?.deposit_amount}</td>
                                <td>{ele?.remarks}</td>
                                <td>
                                    {ele?.deposit_status === 0 && <button type="button" className="btn btn-warning btnyellow-custom">Pending</button>}
                                    {ele?.deposit_status === 1 && <button type="button" className="btn btn-success btngreen-success-custom">Success</button>}
                                    {ele?.deposit_status === 2 && <button type="button" className="btn btn-danger btnred-danger-custom">Rejected</button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
